var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card-actions',[_c('v-spacer'),_c('v-btn',{attrs:{"loading":_vm.sending,"large":"","disabled":_vm.disabled,"color":"primary"},on:{"click":function($event){return _vm.$emit('update')}}},[_vm._v("Atualizar")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }